import { get, post, patch } from 'api/request'

export const API_SALES = "/sales/service"

export const getMyCart = (contactKey, storeId) => get(`${API_SALES}/cart/0/?contact=${contactKey}&store=${storeId}`)
export const getOrderList = (contactKey, storeId, submitted = 1, offset = 0, size = 20 ) => get(`${API_SALES}/order/?contact=${contactKey}&store=${storeId || ''}&submitted=${submitted}`, {
   urlParams: {
      order: '-issue_date',
      offset,
      size
   }
})
export const getSearchOrderList = (contactKey, storeId, submitted = 1, offset = 0, size = 20 ) => get(`${API_SALES}/order/search/?contact=${contactKey}&store=${storeId || ''}&submitted=${submitted}`, {
   urlParams: {
      order: '-issue_date',
      offset,
      size
   }
})
export const getOrderDetail = (key) => get(`${API_SALES}/order/${key}/`)
export const updateMyCart = (contactKey, storeId, data) => patch(`${API_SALES}/cart/0/?contact=${contactKey}&store=${storeId}`, data)
export const getShippingMethods = (contactKey, storeId) => get(`${API_SALES}/cart/0/shipping-methods?contact=${contactKey}&store=${storeId}`)
export const getShippingWarehouses = (contactKey, storeId) => get(`${API_SALES}/cart/0/warehouses?contact=${contactKey}&store=${storeId}`)
export const getPaymentMethods = (contactKey, storeId) => get(`${API_SALES}/cart/0/payment-methods?contact=${contactKey}&store=${storeId}`)
export const placeOrder = (contactKey, storeId) => post(`${API_SALES}/cart/0/place_order/?contact=${contactKey}&store=${storeId}`)
export const cancelOrder = (id) => post(`${API_SALES}/order/${id}/cancel`)
export const revisionOrder = (id, reason) => post(`${API_SALES}/order/${id}/create_revision`, { reason })
export const getShippingAddressList = (contactKey) => get(`${API_SALES}/shipping-address/?contact=${contactKey}`)
export const createShippingAddress = (data) => post(`${API_SALES}/shipping-address/`, data)
export const editShippingAddress = (id, data) => patch(`${API_SALES}/shipping-address/${id}/`, data)
export const applyDiscount = (contactKey, storeId, discount_code) => post(`${API_SALES}/cart/0/add_discount/?contact=${contactKey}&store=${storeId}`, { discount_code })
export const removeDiscount = (contactKey, storeId, discount_id) => post(`${API_SALES}/cart/0/remove_discount/?contact=${contactKey}&store=${storeId}`, { discount_id })
